export default {
  branches: [],
  inActiveBranches: [],
  branch: [],
  province: [],
  cities: [],
  useless: false,
};
